const noIdentifiersCondition = (element: HTMLElement): boolean => {
  return (
    element &&
    element.id === '' &&
    (!element.dataset || typeof element.dataset.testId === 'undefined')
  );
};

const nodePath = (
  element: HTMLElement,
  continuationCondition = noIdentifiersCondition
): HTMLElement[] => {
  const path = [];
  let node = element;

  do {
    path.push(node);
  } while (
    continuationCondition(node) &&
    // tslint:disable-next-line:no-conditional-assignment
    (node = node.parentNode as HTMLElement) !== null &&
    node.nodeType !== Node.DOCUMENT_NODE
    );

  return path.reverse();
};

export default nodePath;
